module.exports = __webpack_public_path__ + "img/file-download-02.0f85797d.svg";